import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store/store";
import Vuebar from "vuebar";
import "./plugins/base";
import VueSkycons from "vue-skycons";
import api from './api';
import CustomGoogleAutocomplete from 'vue-custom-google-autocomplete'
import moment from "moment";
// import x5GMaps from 'x5-gmaps';
// import * as Sentry from "@sentry/vue";

Vue.use(CustomGoogleAutocomplete)
// Vue.use(x5GMaps, { key: 'AIzaSyAvRM83IEcsn6fyv-AInElyG6VThGY3_os', libraries: ['places'] });

Vue.use(VueSkycons, {
  color: "#1e88e5",
});

Vue.prototype.$axios = api

api.interceptors.request.use(
  config => {
    const token = localStorage.getItem("token");
    if (token !== null && token !== 'null' && token !== 'null-new') {
        // console.log('tenemos el token..!!!', token)
      config.headers.common["Authorization"] = `JWT ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

Vue.config.productionTip = false;

Vue.use(Vuebar);

Vue.filter('formatDateTime', function(value) {
   if(value) {
       return moment(String(value)).format('DD/MM/YYYY | HH:mm');
   }
});

Vue.filter('formatDate', function(value) {
   if(value) {
       return moment(String(value)).format('DD/MM/YYYY');
   }
});

Vue.filter('thousands', function(value) {
    if(value) {
        return '$' + value.toLocaleString('en-US', {minimumFractionDigits: 2}) + ' MXN';
    }
});

// Sentry.init({
//   Vue: Vue,
//   dsn: "https://0913db88b3fa4a529a69aa89214f7144@sentry.idooproject.com/28",
// });

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
